import { ChooseSubscriptionPage } from '@/pages/choose-subscription';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/choose-subscription')({
	component: ChooseSubscriptionPage,
});
